const Globalconfig =  {
    "github": {
        "url": "https://github.com/login/oauth/authorize",
        "client_id": "Iv23liw3m0dtDHQ9OzCH",
        "redirect_uri": "https://app.axilock.ai/auth/github/callback",
        "scope":"repo,user",
        "redirect_uri_client": "https://app.axilock.ai/client/github/callback",
        "redirect_uri_app": "https://app.axilock.ai/auth/github-app/callback",
        "url_app_install": "https://github.com/apps/axilock-runner/installations/new"
    },
    "provider": {
        "github": "github"
    }
}

export default Globalconfig